<template>
  <div class="loading">Loading...</div>
</template>
